export default function ({ store, redirect }) {
  // Redirect to menu if cart is empty
  if (process.client && !store.state.cart.items.length) {
    return redirect('/ordering/menu/pizzas')
  }
}
